// DashboardDetails.jsx
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import DashboardTable from '../../../components/ACS-Dashboard/ACS-Dashboard-Blocks/DashboardTable'
import ChartJSBarChart from '../../../components/ACS-Dashboard/ACS-Dashboard-Blocks/BarChart'
import ChartJSPieChart from '../../../components/ACS-Dashboard/ACS-Dashboard-Blocks/PieChart'

const DashboardDetails = () => {
  const [invoiceData, setInvoiceData] = useState([])
  const [chargeData, setChargeData] = useState([])
  const [volumeData, setVolumeData] = useState([])
  const [billingData, setBillingData] = useState([])
  const [shipmentsToday, setShipmentsToday] = useState([])
  const [sortOrder, setSortOrder] = useState('desc')

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [
          invoiceRes,
          chargeRes,
          volumeRes,
          billingRes,
          shipmentsRes
        ] = await Promise.all([
          axios.get('http://localhost:8080/api/invoice-audit-success'),
          axios.get('http://localhost:8080/api/charge-audit-success'),
          axios.get('http://localhost:8080/api/shipment-volume'),
          axios.get('http://localhost:8080/api/billing-timeliness'),
          axios.get('http://localhost:8080/api/shipments-today')
        ])

        const sortFunc = sortOrder === 'asc'
          ? (a, b) => a.successRate - b.successRate
          : (a, b) => b.successRate - a.successRate

        setInvoiceData(
          invoiceRes.data
            .map(item => ({ ...item, color: getBarColor(item.successRate) }))
            .sort(sortFunc)
        )
        setChargeData(
          chargeRes.data
            .map(item => ({ ...item, color: getBarColor(item.successRate) }))
            .sort(sortFunc)
        )
        setVolumeData(volumeRes.data)
        setBillingData(billingRes.data)
        setShipmentsToday(shipmentsRes.data)
      } catch (err) {
        console.error('Dashboard fetch failed', err)
      }
    }
    fetchAll()
  }, [sortOrder])

  const getBarColor = (value) => {
    if (value >= 40) return '#4CAF50' // Green
    if (value >= 25) return '#FFC107' // Amber
    return '#F44336' // Red
  }

  const toggleSortOrder = () => {
    setSortOrder(prev => (prev === 'asc' ? 'desc' : 'asc'))
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">

      {/* Sort Toggle */}
      <div className="col-span-full flex justify-end mb-2">
        <button
          onClick={toggleSortOrder}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
        >
          Sort: {sortOrder === 'asc' ? 'Low to High' : 'High to Low'}
        </button>
      </div>

      {/* Invoice Audit */}
      {invoiceData.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="font-semibold mb-4">Invoice Audit Success Rate</h3>
          <ChartJSBarChart
            data={invoiceData}
            title="Invoice Audit Success Rate"
          />
        </div>
      )}

      {/* Charge Audit */}
      {chargeData.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="font-semibold mb-4">Charge Audit Success Rate</h3>
          <ChartJSBarChart
            data={chargeData}
            title="Charge Audit Success Rate"
          />
        </div>
      )}

      {/* Shipment Volume */}
      {volumeData.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 col-span-full md:col-span-2 hover:shadow-2xl transition-shadow duration-300">
          <h3 className="font-semibold mb-4">Volume of Shipments</h3>
          <ChartJSPieChart data={volumeData} />
        </div>
      )}

      {/* Billing Timeliness */}
      {billingData.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 col-span-full hover:shadow-2xl transition-shadow duration-300">
          <h3 className="font-semibold mb-4">Billing Timeliness by Carrier</h3>
          <DashboardTable
            headers={['Carrier', 'Avg Bill Delay (days)']}
            data={billingData}
          >
            {(row) => (
              <>
                <td className="px-4 py-2">{row.carrierName}</td>
                <td className="px-4 py-2">{row.avgInvoiceDelayDays?.toFixed(2) ?? '—'}</td>
              </>
            )}
          </DashboardTable>
        </div>
      )}

      {/* Shipments Today */}
      {shipmentsToday.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg p-6 col-span-full hover:shadow-2xl transition-shadow duration-300">
          <h3 className="font-semibold mb-4">Shipments Today</h3>
          <DashboardTable
            headers={['Shipment #', 'Client', 'Origin', 'Destination', 'Order Value', 'Status']}
            data={shipmentsToday}
          >
            {(row) => (
              <>
                <td className="px-4 py-2">{row.id}</td>
                <td className="px-4 py-2">{row.receiverName}</td>
                <td className="px-4 py-2">{row.portOfOrigin}</td>
                <td className="px-4 py-2">{row.portOfDestination}</td>
                <td className="px-4 py-2">${Number(row.orderValue).toFixed(2)}</td>
                <td className="px-4 py-2">{row.status}</td>
              </>
            )}
          </DashboardTable>
        </div>
      )}

    </div>
  )
}

export default DashboardDetails
